const SCHEDULE_COLORS = ['green', 'orange', 'red', 'purple', 'blue', 'pink', 'teal'];

export const getScheduleColor = (id) => SCHEDULE_COLORS[id % SCHEDULE_COLORS.length];

export const getSpecialityTagVariant = (specialityName) => {
    if (!specialityName) return 1;

    const firstLetter = specialityName.trim().charAt(0).toUpperCase();

    const mapping = {
        'G': 7,
        'P': 2,
        'C': 8,
        'O': 9,
        'N': 10,
        'I': 11,
        'T': 12
    };

    if (mapping[firstLetter]) {
        return mapping[firstLetter];
    }

    // Use a deterministic hash to prevent React re-render flickering
    let hash = 0;
    for (let i = 0; i < specialityName.length; i++) {
        hash = specialityName.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return (Math.abs(hash) % 12) + 1;
};
